export default __webpack_public_path__ + "static/media/menu.d78a573c.svg";